import { REGEXP } from './constants';

export const parseAdditionalRecipients = (text) => (
  text.trim().split(/[\s,]+/).filter(Boolean)
);

export const getInvalidAdditionalRecipients = (text) => (
  parseAdditionalRecipients(text).filter((email) => !REGEXP.email.test(email))
);

export const canSendNotifications = (allocUsers, additionalRecipients) => {
  const mainRecipients = allocUsers.filter((item) => item.isChecked).length;
  const hasAdditionalRecipients = additionalRecipients.trim().length > 0;
  return mainRecipients > 0 || hasAdditionalRecipients;
};

export const buildNotificationAddresses = (allocUsers, additionalRecipients) => {
  const checkedAddresses = allocUsers
    .map((item) => (item.isChecked ? item['user-uid'] : ''))
    .filter(Boolean);

  const additionalEmails = parseAdditionalRecipients(additionalRecipients);

  return [...checkedAddresses, ...additionalEmails].join(', ');
};
